import InfiniteScroll from "react-infinite-scroller";
import AssetItem from "../Assets/AssetItem";
import InstrumentationItem from "../Instrumentations/InstrumentationItem";
import NodeItem from "../Nodes/NodeItem";

import List from "../List/List";

import {
  accessRightsShape,
  assetsShape,
  instrumentationShape,
  nodeShape,
} from "../../shapes";
import { useSearch } from "../../hooks/useSearch";

type Props = {
  accessRights?: accessRightsShape;
  isLoading: boolean;
  hasMore: boolean;
  items: (nodeShape | instrumentationShape | assetsShape)[];
  loadMore: $TSFixMeFunction;
  node?: nodeShape;
  onItemRemoved: $TSFixMeFunction;
};

export function AllObjectsList({
  accessRights,
  isLoading,
  hasMore,
  items,
  loadMore,
  node,
  onItemRemoved,
}: Props) {
  // @ts-expect-error TS(2554) FIXME: Expected 1 arguments, but got 0.
  const { options } = useSearch();

  const renderItem = (item: $TSFixMe) => {
    const commonProp = {
      showItemMenu: true,
      options,
    };

    if (item.itemType === "node") {
      return (
        <NodeItem
          key={`n${item.id}`}
          // @ts-expect-error TS(2322) FIXME: Type '{ showItemMenu: boolean; options: any; key: ... Remove this comment to see the full error message
          node={item}
          parentNode={node || item}
          onNodeRemoved={onItemRemoved}
          {...commonProp}
        />
      );
    }
    if (item.itemType === "instrumentation") {
      return (
        <InstrumentationItem
          key={`i${item.id}`}
          // @ts-expect-error TS(2322) FIXME: Type '{ showItemMenu: boolean; options: any; key: ... Remove this comment to see the full error message
          instrumentation={item}
          parentNode={node}
          parentAccessRights={accessRights}
          onInstrumentationRemoved={onItemRemoved}
          {...commonProp}
        />
      );
    }
    if (item.itemType === "asset") {
      return (
        <AssetItem
          key={`a${item.id}`}
          // @ts-expect-error TS(2322) FIXME: Type '{ showItemMenu: boolean; options: any; key: ... Remove this comment to see the full error message
          asset={item}
          parentNode={node}
          parentAccessRights={accessRights}
          onAssetRemoved={onItemRemoved}
          {...commonProp}
        />
      );
    }
    return null;
  };

  return (
    <List id="nodes-list">
      <InfiniteScroll
        initialLoad={false}
        loadMore={loadMore}
        hasMore={!isLoading && hasMore}
        threshold={700}
        id="objects"
      >
        {items.map(renderItem)}
      </InfiniteScroll>
    </List>
  );
}

export default AllObjectsList;
